export enum SoundFiles {
  CLICK = 1,
  QUEUE_MATCH = 2,
  BATTLECRY_1 = 3.1,
  BATTLECRY_2 = 3.2,
  BATTLECRY_3 = 3.3,
  BATTLECRY_4 = 3.4,
  BATTLECRY_5 = 3.5,
  CARD_CLICK = 4,
  MOVE_1 = 5.1,
  MOVE_2 = 5.2,
  MOVE_3 = 5.3,
  MOVE_4 = 5.4,
  MOVE_5 = 5.5,
  ROUND_WIN = 6,
  ROUND_LOSE = 7,
  ROUND_DRAW = 8,
  FIGHT_WIN = 9,
  FIGHT_LOSE = 10,
  FIGHT_DRAW = 11,
  CASH_RECEIVE = 12,
  GOT_CASH = 13,
  RANK_UPGRADE = 14
}
